import { useEffect } from "react";

// True quando l'app gira dentro un iframe (embed sul sito WordPress)
export const inIframe = (() => {
  try { return window.self !== window.top; } catch (e) { return true; }
})();

// Apre un percorso dell'app A TUTTO SCHERMO nella stessa scheda (esce dall'iframe)
export function openFullscreen(path) {
  const url = window.location.origin + path;
  if (inIframe) {
    try { window.top.location.href = url; return; } catch (e) { /* fallback sotto */ }
  }
  window.location.href = url;
}

// Comunica al sito ospitante l'altezza del contenuto → iframe auto-adattante (niente scroll interno)
export function useEmbedAutoHeight() {
  useEffect(() => {
    if (!inIframe) return;
    // In iframe: neutralizziamo min-height:100vh (min-h-screen) che gonfia l'altezza
    // e rende l'iframe lunghissimo/bianco. Così l'altezza = contenuto reale.
    const style = document.createElement("style");
    style.textContent = "html,body{height:auto!important;min-height:0!important;background:transparent!important}.min-h-screen{min-height:0!important}";
    document.head.appendChild(style);

    let last = 0;
    const post = () => {
      const root = document.getElementById("root");
      const h = Math.ceil(root ? root.getBoundingClientRect().height : (document.body ? document.body.scrollHeight : 0));
      if (h > 0 && Math.abs(h - last) > 2) {
        last = h;
        try { window.parent.postMessage({ type: "arete-embed-height", height: h }, "*"); } catch (e) {}
      }
    };
    post();
    let ro;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(post);
      const root = document.getElementById("root");
      if (root) ro.observe(root);
      ro.observe(document.body);
    }
    window.addEventListener("load", post);
    window.addEventListener("resize", post);
    const t = setInterval(post, 1000);
    return () => {
      if (ro) ro.disconnect();
      window.removeEventListener("load", post);
      window.removeEventListener("resize", post);
      clearInterval(t);
      style.remove();
    };
  }, []);
}
